let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kJRc8")).then(() => parcelRequire('dVfs0'));